<template>
  <div class="dict">
    <el-form :model="formData" ref="formData" label-width="100px">
      <el-collapse v-model="activeNames" class="collapse-main-content">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('transportDeliveryOrder.form.order') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundNo')">
                  <el-input
                    v-model="formData.outboundNo"
                    :disabled="true"
                    :placeholder="this.$t('transportDeliveryOrder.form.outboundNoPlaceholder')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundCreatePerson')">
                  <el-input v-model="formData.outboundCreatePersonName" :disabled="true">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundStatus')">
                  <el-input v-model="formData.outboundStatusName" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.companyName')">
                  <el-tooltip
                    :disabled="!formData.companyName"
                    class="item"
                    effect="dark"
                    :content="formData.companyName"
                    placement="top"
                  >
                    <el-input v-model="formData.companyName" :disabled="true"> </el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.departmentName')">
                  <el-tooltip
                    :disabled="!formData.departmentName"
                    class="item"
                    effect="dark"
                    :content="formData.departmentName"
                    placement="top"
                  >
                    <el-input v-model="formData.departmentName" :disabled="true"> </el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundCreateDate')">
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.outboundCreateDate"
                    :disabled="true"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundPrintTime')">
                  <el-input v-model="formData.outboundPrintTime" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('transportDeliveryOrder.form.info') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6" v-if="flag == 0">
                <el-form-item
                  prop="salesLadingNo"
                  :label="this.$t('transportDeliveryOrder.form.salesLadingNo')"
                >
                  <el-input v-model="formData.salesLadingNo" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="flag == 1">
                <el-form-item
                  prop="allotNo"
                  :label="this.$t('transportDeliveryOrder.form.allotNo')"
                >
                  <el-input v-model="formData.allotNo" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="flag == 2">
                <el-form-item
                  prop="returnAndChangeNo"
                  :label="this.$t('transportDeliveryOrder.form.returnAndChangeNo')"
                >
                  <el-input
                    v-model="formData.returnAndChangeNo"
                    :disabled="true"
                    :placeholder="
                      this.$t('transportDeliveryOrder.form.returnAndChangeNoPlaceholder')
                    "
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="deliveryMethod"
                  :label="this.$t('transportDeliveryOrder.form.deliveryMethod')"
                >
                  <el-select
                    style="width: 100%"
                    filterable
                    v-model="formData.deliveryMethod"
                    :disabled="canEdit"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="item in instructionTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="outboundCreateTime"
                  :label="this.$t('transportDeliveryOrder.form.outboundCreateTime')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.outboundCreateTime"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="validDateTo"
                  :label="this.$t('transportDeliveryOrder.form.validDateTo')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.validDateTo"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="contactPerson"
                  :label="this.$t('transportDeliveryOrder.form.contactPerson')"
                >
                  <el-input v-model="formData.contactPerson" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="contactPhone"
                  :label="this.$t('transportDeliveryOrder.form.contactPhone')"
                >
                  <el-input
                    v-model="formData.contactPhone"
                    :disabled="canEdit"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="outboundStorageNo"
                  :label="this.$t('transportDeliveryOrder.form.outboundStorageNo')"
                >
                  <el-input v-model="formData.outboundStorageName" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="storageContactPhone"
                  :label="this.$t('transportDeliveryOrder.form.storageContactPhone')"
                >
                  <el-input
                    v-model="formData.storageContactPhone"
                    :disabled="canEdit"
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  :label="this.$t('transportDeliveryOrder.form.outboundBusinessPerson')"
                >
                  <el-input v-model="formData.outboundBusinessPersonName" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="outboundType"
                  :label="this.$t('transportDeliveryOrder.form.outboundType')"
                >
                  <el-select
                    style="width: 100%"
                    filterable
                    v-model="formData.outboundType"
                    :disabled="canEdit"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="item in outboundTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="flag != 1">
                <el-form-item
                  prop="customerNo"
                  :label="this.$t('transportDeliveryOrder.form.customerNo')"
                >
                  <el-input v-model="formData.customerName" :disabled="true" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.outboundDepartment')">
                  <el-input v-model="formData.outboundDepartmentName" :disabled="true"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.storageContactEmail')">
                  <el-input
                    v-model="formData.storageContactEmail"
                    disabled
                    :placeholder="this.$t('transportDeliveryOrder.form.writeStorageContactEmail')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('logistics.baseInformation.outCode')" prop="externalNo">
                  <el-input
                    v-model="formData.externalNo"
                    :placeholder="$t('logistics.baseInformation.outCode')"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="flag == 0">
              <el-col>
                <el-form-item prop="mark" label="备注">
                  <el-input
                    v-model="formData.mark"
                    :disabled="canEdit"
                    type="textarea"
                    maxlength="256"
                    :rows="3"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col>
                <el-form-item
                  prop="deliveryNote"
                  :label="this.$t('transportDeliveryOrder.form.deliveryNote')"
                >
                  <el-input
                    v-model="formData.deliveryNote"
                    :disabled="canEdit"
                    type="textarea"
                    maxlength="256"
                    :rows="3"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('transportDeliveryOrder.form.fee') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item
                  prop="isIncludeOutboundExpense"
                  :label="this.$t('transportDeliveryOrder.form.isIncludeOutboundExpense')"
                >
                  <el-select
                    style="width: 100%"
                    filterable
                    v-model="formData.includeOutboundExpense"
                    :disabled="canEdit"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="item in isInsureTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('transportDeliveryOrder.form.isSettled')">
                  <el-checkbox v-model="formData.isSettled" :disabled="true"></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 结算费用表格 -->
            <div class="tableStyle" v-if="isIncludeOutboundExpense == 0">
              <vxe-table
                border
                show-overflow
                resizable
                ref="fee"
                class="vxe-table-element"
                size="mini"
                align="left"
                :auto-resize="true"
                :data="rowData.fee"
                :toolbar="tableToolbar"
                :edit-config="editConfig"
              >
                <vxe-table-column
                  type="index"
                  width="60"
                  :title="$t('table.index')"
                ></vxe-table-column>
                <vxe-table-column
                  field="expenseType"
                  :title="$t('transportDeliveryOrder.form.outboundExpense.expenseType')"
                />
                <vxe-table-column
                  field="expenseRate"
                  :title="$t('transportDeliveryOrder.form.outboundExpense.expenseRate')"
                >
                  <template v-slot="{ row }">
                    {{ $baseRequest.formatTableColumn(row.expenseRate, $globalVar.iPoint) }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="outboundQuantity"
                  :title="$t('transportDeliveryOrder.form.outboundExpense.outboundQuantity')"
                >
                  <template v-slot="{ row }">
                    {{ $baseRequest.formatTableColumn(row.outboundQuantity, $globalVar.qPoint) }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="outboundExpense"
                  :title="$t('transportDeliveryOrder.form.outboundExpense.outboundExpense')"
                >
                  <template v-slot="{ row }">
                    {{ $baseRequest.formatTableColumn(row.outboundExpense) }}
                  </template>
                </vxe-table-column>
              </vxe-table>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('transportDeliveryOrder.form.goodInfo') }}
            </div>
          </template>
          <div class="collapse-content">
            <div class="tableStyle">
              <vxe-grid
                border
                show-overflow
                resizable
                ref="product"
                class="vxe-table-element"
                size="mini"
                align="center"
                :auto-resize="true"
                :data="rowData.product"
              >
                <vxe-table-column
                  field="productNo"
                  :title="$t('transportDeliveryOrder.form.good.productNo')"
                />
                <vxe-table-column
                  field="productName"
                  :title="$t('transportDeliveryOrder.form.good.productName')"
                />
                <vxe-table-column
                  field="productUnitName"
                  :title="$t('transportDeliveryOrder.form.good.productUnit')"
                />
                <vxe-table-column
                  field="distributionBatchNo"
                  :title="$t('transportDeliveryOrder.form.good.businessInboundBatchNo')"
                />
                <vxe-table-column
                  field="remainingOutQuantity"
                  width="100"
                  :title="$t('transportDeliveryOrder.copySearchTable.remainingQuantityOut')"
                >
                  <template v-slot="{ row }">
                    {{
                      $baseRequest.formatTableColumn(row.remainingOutQuantity, $globalVar.qPoint)
                    }}
                  </template>
                </vxe-table-column>
                <vxe-table-column :title="$t('transportDeliveryOrder.form.good.businessOrder')">
                  <vxe-table-column
                    field="businessOrderQuantity"
                    width="160"
                    :title="$t('transportDeliveryOrder.form.good.businessOrderQuantity')"
                  >
                    <template v-slot="{ row }">
                      {{
                        $baseRequest.formatTableColumn(row.businessOrderQuantity, $globalVar.qPoint)
                      }}
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="businessOrderPackage"
                    width="160"
                    :title="$t('transportDeliveryOrder.form.good.businessOrderPackage')"
                  >
                    <template v-slot="{ row }">
                      {{
                        $baseRequest.formatTableColumn(row.businessOrderPackage, $globalVar.qPoint)
                      }}
                    </template>
                  </vxe-table-column>
                </vxe-table-column>
                <vxe-table-column :title="$t('transportDeliveryOrder.form.good.storageShouldSend')">
                  <vxe-table-column
                    field="storageShouldSendQuantity"
                    :title="$t('transportDeliveryOrder.form.good.storageShouldSendQuantity')"
                  >
                    <template v-slot="{ row }">
                      {{
                        $baseRequest.formatTableColumn(
                          row.storageShouldSendQuantity,
                          $globalVar.qPoint
                        )
                      }}
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="storageShouldSendPackage"
                    :title="$t('transportDeliveryOrder.form.good.storageShouldSendPackage')"
                  >
                    <template v-slot="{ row }">
                      {{
                        $baseRequest.formatTableColumn(
                          row.storageShouldSendPackage,
                          $globalVar.qPoint
                        )
                      }}
                    </template>
                  </vxe-table-column>
                </vxe-table-column>
                <vxe-table-column :title="$t('transportDeliveryOrder.form.good.storageSend')">
                  <vxe-table-column
                    field="storageSendQuantity"
                    :title="$t('transportDeliveryOrder.form.good.storageSendQuantity')"
                  >
                    <template v-slot="{ row }">
                      {{
                        $baseRequest.formatTableColumn(row.storageSendQuantity, $globalVar.qPoint)
                      }}
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="storageSendPackage"
                    :title="$t('transportDeliveryOrder.form.good.storageSendPackage')"
                  >
                    <template v-slot="{ row }">
                      {{
                        $baseRequest.formatTableColumn(row.storageSendPackage, $globalVar.qPoint)
                      }}
                    </template>
                  </vxe-table-column>
                </vxe-table-column>
                <vxe-table-column
                  field="customerReceiveQuantity"
                  :title="$t('transportDeliveryOrder.form.good.customerReceiveQuantity')"
                >
                  <template v-slot="{ row }">
                    {{
                      $baseRequest.formatTableColumn(row.customerReceiveQuantity, $globalVar.qPoint)
                    }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="nameVoyageLicense"
                  :title="$t('transportDeliveryOrder.form.good.nameVoyageLicense')"
                />
                <vxe-table-column
                  field="warehouseReceiptsNo"
                  :title="$t('transportDeliveryOrder.form.good.warehouseReceiptsNo')"
                />
                <vxe-table-column field="mark" :title="$t('transportDeliveryOrder.form.good.mark')">
                </vxe-table-column>
                <vxe-table-column
                  field="shipComplete"
                  :title="$t('transportDeliveryOrder.form.good.shipComplete')"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.shipComplete == 'Y' ? '是' : '否' }}</span>
                  </template>
                </vxe-table-column>
              </vxe-grid>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('transportDeliveryOrder.form.transportInfo') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item
                  prop="shippingMethod"
                  :label="this.$t('transportDeliveryOrder.form.shippingMethod')"
                  label-width="70px"
                >
                  <el-select
                    style="width: 100%"
                    filterable
                    v-model="formData.shippingMethod"
                    :disabled="canEdit"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="item in deliveryMethodList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 运输费用表格 -->
            <div class="tableStyle">
              <vxe-grid
                border
                show-overflow
                resizable
                ref="transport"
                class="vxe-table-element"
                size="mini"
                align="left"
                :auto-resize="true"
                :data="rowData.transport"
              >
                <vxe-table-column
                  type="index"
                  width="60"
                  :title="$t('table.index')"
                ></vxe-table-column>
                <vxe-table-column
                  field="nameVoyageLicense"
                  :title="$t('transportDeliveryOrder.form.transport.nameVoyageLicense')"
                ></vxe-table-column>
                <vxe-table-column
                  field="freightInformation"
                  :title="$t('transportDeliveryOrder.form.transport.freightInformation')"
                ></vxe-table-column>
                <vxe-table-column
                  field="contactPerson"
                  :title="$t('transportDeliveryOrder.form.transport.contactPerson')"
                ></vxe-table-column>
                <vxe-table-column
                  field="contactPhoneNo"
                  :title="$t('transportDeliveryOrder.form.transport.contactPhoneNo')"
                ></vxe-table-column>
                <vxe-table-column
                  field="identityCardNumber"
                  :title="$t('transportDeliveryOrder.form.transport.identityCardNumber')"
                ></vxe-table-column>
                <vxe-table-column field="mark" title="备注"></vxe-table-column>
              </vxe-grid>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          name="6"
          v-if="this.formData.outboundStatus == '2' || this.formData.outboundStatus == '1'"
        >
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('transportDeliveryOrder.form.printHistory') }}
            </div>
          </template>
          <div class="collapse-content">
            <div class="tableStyle">
              <upload
                ref="upload"
                v-bind:tableData="attachmentCategoryDataList"
                :printShow="false"
                v-bind:isShow="false"
                @upDataHistory="getHistoryList"
                @upDataNo="getUpDataNo"
              />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          name="7"
          v-if="this.formData.outboundStatus == '2' || this.formData.outboundStatus == '1'"
        >
          <template slot="title">
            <div class="collapse-title-pre"><span></span>传真历史</div>
          </template>
          <div class="collapse-content">
            <div class="tableStyle">
              <faxHistory
                ref="faxHistory"
                v-bind:tableData="faxList"
                :printShow="false"
                v-bind:isShow="false"
              />
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        v-if="this.formData.outboundStatus != '2'"
        @click="gotoEdit"
        v-hasPermi="['2021050814332825712']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.edit') }}</el-button
      >
      <!-- <el-button v-if="this.formData.outboundStatus=='2'" type="primary" @click="gotoEdit" :loading="load" class="fixed-bottom-btn">短信通知</el-button> -->

      <el-popover
        v-if="this.formData.outboundStatus == '2' || this.formData.outboundStatus == '1'"
        ref="popover"
        popper-class="el-popper-search"
        placement="bottom"
        trigger="click"
        v-model="dialogAdd"
      >
        <div>
          <el-button
            type="primary"
            @click="openCustomerSendMessage"
            :loading="load"
            class="bottom-btn"
            >{{ $t('transportDeliveryOrder.btnList.msgToCustomer') }}</el-button
          ><br />
          <el-button
            type="primary"
            @click="openWarehouseSendMessage"
            :loading="load"
            class="bottom-btn"
            >{{ $t('transportDeliveryOrder.btnList.msgToWareHouse') }}</el-button
          >
        </div>
        <el-button type="primary" :loading="load" class="fixed-bottom-btn" slot="reference">{{
          $t('transportDeliveryOrder.btnList.message')
        }}</el-button>
      </el-popover>

      <!-- <el-button v-if="this.formData.outboundStatus=='2'" type="primary" @click="gotoEdit" :loading="load" class="fixed-bottom-btn">邮件</el-button> -->
      <el-button
        type="primary"
        v-if="this.formData.outboundStatus == '2' || this.formData.outboundStatus == '1'"
        @click="openSendEmail"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('transportDeliveryOrder.btnList.email') }}</el-button
      >
      <el-button
        v-if="this.formData.outboundStatus == '2' && this.formData.outboundType != 'CK04'"
        type="primary"
        @click="updateOutboundStatus(3)"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.revert') }}</el-button
      >
      <el-button
        v-if="this.formData.outboundStatus == '1' || this.formData.outboundStatus == '3'"
        type="primary"
        @click="updateOutboundStatus(4)"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <el-button
        v-if="this.formData.outboundStatus == '2' || this.formData.outboundStatus == '1'"
        type="primary"
        @click="print(0)"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('transportDeliveryOrder.btnList.printBill') }}</el-button
      >
      <el-button
        v-if="this.formData.outboundStatus == '2' || this.formData.outboundStatus == '1'"
        type="primary"
        @click="print(1)"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('transportDeliveryOrder.btnList.printLetter') }}</el-button
      >
      <el-button
        v-if="this.formData.outboundStatus == '2' || this.formData.outboundStatus == '1'"
        type="primary"
        @click="sendFax()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('transportDeliveryOrder.btnList.sendFax') }}</el-button
      >
    </div>
    <CustomerSendMessage ref="customerSendMessage" />
    <WarehouseSendMessage ref="warehouseSendMessage" />
    <WarehouseSendEmail ref="warehouseSendEmail" />
    <print-dialog
      ref="printDialog"
      :formData="this.formData"
      :codeNumber="this.$route.query.outboundNo"
      @getHistoryPageList="getHistoryPageList"
      :tableData="printTableData"
    ></print-dialog>
    <send-fax-dialog
      ref="sendFaxDialog"
      :formData="this.formData"
      :codeNumber="this.$route.query.outboundNo"
      :tableData="faxTableData"
    ></send-fax-dialog>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  // import SearchModal from '@/components/SearchModal';
  import API from '@/api/logisticsCenter/transportDeliveryOrder.js';
  import DataBaseAPI from '@/api/dataBase';
  import formRules from './rules/rules';
  import column from './columns/columns';
  import masterObj from '@/common/js/masterObj';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import CustomerSendMessage from './component/customerSendMessage';
  import WarehouseSendMessage from './component/warehouseSendMessage';
  import WarehouseSendEmail from './component/sendEmail';
  import printDialog from './component/printDialog';
  import sendFaxDialog from './component/sendFaxDialog';
  // import SiruiTable from '@/components/SiruiTable';
  import upload from './component/upload';
  import faxHistory from './component/faxHistory';
  export default {
    components: {
      // SearchModal,
      // inputNumberAd,
      upload,
      CustomerSendMessage,
      WarehouseSendMessage,
      WarehouseSendEmail,
      printDialog,
      sendFaxDialog,
      // SiruiTable,
      faxHistory,
    },
    name: 'transportDeliveryOrderDetail',
    data() {
      let params = this.$route.query || null;
      let newDate = new Date();
      newDate.setDate(newDate.getDate() + 3);
      //如果是前三天就-3
      // newDate.getDate(); //得到后三天的时间
      return {
        attachmentCategoryDataList: [], //打印销售提货单历史
        faxList: [], //传真历史
        dialogAdd: false,
        checked: [],
        load: false,
        canEdit: true,
        rules: formRules.formRules,
        flag: this.$route.query.flag,
        instructionTypeList: [], //交货方式
        deliveryMethodList: [],
        outboundTypeList: [],
        goodColumnList: column.goodColumnList,
        transportColumnList: column.transportColumnList,
        //feeColumnList:column.feeColumnList,
        goodRules: formRules.goodRules,
        tableToolbar: {},
        editConfig: { trigger: 'click', mode: 'row' },
        lastCheckboxValue: '', //记录发货备注中多选框的值
        isIncludeOutboundExpense: 1,
        isInsureTypeList: [
          { id: '0', name: this.$t('transportDeliveryOrder.label.no') },
          { id: '1', name: this.$t('transportDeliveryOrder.label.yes') },
        ],
        rowData: {
          fee: [],
          product: [],
          transport: [],
        },
        row: {
          fee: {
            expenseType: null,
            expenseRate: 0,
            outboundQuantity: 0,
            outboundExpense: 0,
          },
          transport: {
            deliveryType: '',
            nameVoyageLicense: '',
            freightInformation: '',
            contactPerson: '',
            contactPhoneNo: '',
            identityCardNumber: '',
            mark: '',
          },
        },
        rowIndex: {
          fee: 0,
          product: 0,
          transport: 0,
        },
        options: [
          this.$t('transportDeliveryOrder.form.checkbox1'),
          this.$t('transportDeliveryOrder.form.checkbox2'),
          this.$t('transportDeliveryOrder.form.checkbox3'),
          this.$t('transportDeliveryOrder.form.checkbox4'),
        ],
        activeNames: ['1', '2', '3', '4', '5', '6', '7'], //默认展开那些面板，
        type: params ? params.type : '',
        formData: {
          storageContactEmail: null,
          outboundPrintTime: 0,
          contactPerson: null,
          contactPersonName: null,
          //deliveryMethod:this.$route.query.flag==0 ? params.
          deliveryNote: '',
          salesLadingNo: params && params.flag == 0 && params.no ? params.no : null,
          allotNo: params && params.flag == 1 && params && params.no ? params.no : null,
          returnAndChangeNo: '',
          outboundCreateTime: new Date(),
          validDateTo: newDate,
          outboundCreateDate: new Date(),
          outboundStatusName: this.$t('transportDeliveryOrder.label.draft'),
          outboundStatus: '0',
        },
        expenseTypeData: [],
        outboundStatusData: [
          '',
          this.$t('transportDeliveryOrder.label.theSaved'),
          this.$t('transportDeliveryOrder.label.executed'),
          this.$t('transportDeliveryOrder.label.hadWithdrawn'),
          this.$t('transportDeliveryOrder.label.haveDeleted'),
        ],
        partner: masterObj.customer,
        warehouse: masterObj.warehouse,
        person: masterObj.person,
        printTableData: [], //打印
        faxTableData: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    mounted() {
      if (this.$route.name === 'transportDeliveryOrderAdd') {
        let userInfo = this.userInfo.userInfo;
        this.formData.contactPersonName = userInfo.userName;
        this.formData.contactPerson = userInfo.userName;
        this.formData.companyCode = userInfo.companyCode;
        this.formData.companyName = userInfo.companyName;
        this.formData.departmentCode = userInfo.departmentCode;
        this.formData.departmentName = userInfo.departmentName;
        this.formData.outboundCreatePersonNo = userInfo.userCode;
        this.formData.outboundCreatePersonName = userInfo.userName;
        this.formData.outboundBusinessPersonNo = userInfo.userCode;
        this.formData.outboundBusinessPersonName = userInfo.userName;
      }
      this.getDic();
      this.getData(); //获取销售提单/库存调拨单详情
    },
    methods: {
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //交货方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'deliver_type',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.instructionTypeList = res.data.data;
            }
          });
        //出库类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'outgoing_type',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.outboundTypeList = res.data.data;
            }
          });
        //运输方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'delivery_method',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.deliveryMethodList = res.data.data;
            }
          });
        //费用类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'rate_types',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.expenseTypeList = res.data.data;
              for (var item of res.data.data) {
                this.expenseTypeData[item['value']] = item['label'];
              }
            }
          });
      },
      //获取销售提单/库存调拨单详情
      getData() {
        let outboundNo = this.$route.query.outboundNo;
        this.$axios
          .get(API.DETAIL_TRANSPORTDELIVERYORDER_API + outboundNo)
          .then((res) => {
            if (0 == res.data.code) {
              this.formData = res.data.data;
              this.formData.salesLadingNo = res.data.data.salesLadingNo;
              this.formData.allotNo = res.data.data.allotNo;
              this.formData.returnAndChangeNo = res.data.data.returnAndChangeNo;
              this.formData.outboundStatusName =
                this.outboundStatusData[this.formData.outboundStatus];
              let flag = this.formData.includeOutboundExpense;
              this.formData.includeOutboundExpense =
                flag == true
                  ? this.$t('transportDeliveryOrder.label.yes')
                  : this.$t('transportDeliveryOrder.label.no');
              this.isIncludeOutboundExpense = flag == true ? 0 : 1;
              this.rowData.fee = res.data.data.outBoundExpenseList;
              if (this.rowData.fee && this.rowData.fee.length > 0) {
                this.rowData.fee.map((item) => {
                  item.expenseType = this.expenseTypeData[item.expenseType];
                });
              }
              this.rowData.transport = res.data.data.deliveryTransportList;
              this.rowData.product = res.data.data.outboundDetailList;
            }
          })
          .finally(() => {
            this.getFaxList();
            this.getHistoryList();
          });
      },
      getHistoryList() {
        let params = {
          dataType: 'DISTRIBUTION_OUTBOUND',
          dataNo: this.formData.outboundNo,
          attachmentCategory: '1',
        };
        this.$axios.post(API.HISTORY_LIST_ATTACHMENT_PAGE, params).then((res) => {
          if (res.data.code == 0) {
            this.attachmentCategoryDataList = res.data.data;
          }
        });
      },
      // 查询传真历史
      getFaxList() {
        let params = {
          docType: 'DISTRIBUTION_OUTBOUND',
          docId: this.formData.id,
          pageNum: 1,
          pageSize: 999,
        };
        this.$axios.post(DataBaseAPI.FAXLIST, params).then((res) => {
          if (res.data.code == 0) {
            this.faxList = res.data.data.records;
          }
        });
      },
      //次数打印
      getUpDataNo(row) {
        let params = {
          attachmentId: row.attachmentId,
        };
        this.$axios.post(API.ADD_PRINT_NUMBER, params).then((res) => {
          if (res.data.code == 0) {
            this.getHistoryList();
          }
        });
      },
      //跳转到修改页面
      gotoEdit() {
        let path = {
          fromPath: {
            path: '/logistics/transportDeliveryOrderDetail',
            name: 'transportDeliveryOrderDetail',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/logistics/transportDeliveryOrderEdit',
            name: 'transportDeliveryOrderEdit',
            meta: {
              keepAlive: true,
            },
            query: {
              outboundNo: this.formData.outboundNo,
              type: 1,
              flag:
                this.formData.outboundType === 'CK01'
                  ? 0
                  : this.formData.outboundType === 'CK02'
                  ? 1
                  : 2,
            }, //type 0:新增 1:修改
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      getHistoryPageList(val) {
        if (val.data.code == 0) {
          this.attachmentCategoryDataList = val.data.data;
          this.formData.outboundPrintTime = val.data.data.length;
        }
      },
      //打开发送短信至客户
      openCustomerSendMessage() {
        this.$refs.customerSendMessage.openDialog(true, this.formData);
      },
      //打开发送短信至仓库
      openWarehouseSendMessage() {
        this.$refs.warehouseSendMessage.openDialog(true, this.formData);
      },
      //打开发送邮件
      openSendEmail() {
        this.$refs.warehouseSendEmail.openDialog(true, this.formData);
      },
      //打印功能
      print(val) {
        this.printTableData = [];
        const params = {
          handleClass: 'print',
          moduleCode: 'outbound',
          templateCode: val == '1' ? 'outboundPrintOne' : 'outboundPrintTwo',
        };
        this.$axios.post(DataBaseAPI.GET_FILE, params).then((res) => {
          if (res.data.code === 0) {
            this.printTableData = res.data.data || [];
          }
        });
        this.$refs.printDialog.openDialog(val, this.formData.outboundNo);
      },
      sendFax() {
        this.faxTableData = [];
        const params = {
          handleClass: 'print',
          moduleCode: 'outbound',
          templateCode: 'outboundFax',
        };
        this.$axios.post(DataBaseAPI.GET_FILE, params).then((res) => {
          if (res.data.code === 0) {
            this.faxTableData = res.data.data || [];
          }
        });
        this.$refs.sendFaxDialog.openDialog(this.formData);
      },
      //撤销/删除
      updateOutboundStatus(status) {
        let params = {
          outboundNo: this.formData.outboundNo,
          outboundStatus: status,
          version: this.formData.version,
        };
        let content = '';
        let title = '';
        if (status == 3) {
          title = this.$t('confirm.revert');
          content = this.$t('confirm.revertContent');
        } else {
          title = this.$t('confirm.delete');
          content = this.$t('confirm.content');
        }
        this.$confirmAction(title, content)
          .then(() => {
            this.$axios.post(API.DELETE_TRANSPORTDELIVERYORDER_API, params).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                //返回列表页面
                let path = {
                  fromPath: {
                    path: '/logistics/transportDeliveryOrderDetail',
                    name: 'transportDeliveryOrderDetail',
                    meta: {
                      keepAlive: true,
                    },
                  },
                  toPath: {
                    path: '/logistics/transportDeliveryOrderList',
                    name: 'transportDeliveryOrderList',
                    meta: {
                      keepAlive: false,
                    },
                  },
                };
                this.$store.dispatch('tagsView/backTabView', path).then(() => {
                  this.$nextTick(() => {
                    this.$router.push(path.toPath);
                  });
                });
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
  .bottom-btn {
    margin-bottom: 10px;
    text-align: center;
    width: 150px;
  }
</style>
